<template>
    <common-modal width="medium" @close="emitEvent({ name: eventName })">
        <common-content-spacer v-if="!isAlreadyDeclined && !isAlreadyObtained" height="small">
            <header>
                <h4>
                    {{ title }}
                    <br />
                    {{ $t('pages.referrals.show.insurance_modal.question') }}
                </h4>
            </header>
            <main>
                <common-buttons>
                    <common-button
                        :label="$t('pages.referrals.show.insurance_modal.buttons.not_obtained')"
                        type="secondary"
                        @click="emitEvent({ name: eventName })"
                    ></common-button>
                    <common-button
                        :label="$t('pages.referrals.show.insurance_modal.buttons.declined')"
                        type="secondary"
                        @click="declineInsuranceAuth"
                    ></common-button>
                    <common-button
                        :label="$t('pages.referrals.show.insurance_modal.buttons.obtained')"
                        type="primary"
                        @click="obtainInsuranceAuth"
                    ></common-button>
                </common-buttons>
            </main>
        </common-content-spacer>
        <insurance-auth-status
            v-else
            :isObtained="isAlreadyObtained"
            :message="$t('pages.referrals.show.insurance_auth_status.reload_message')"
        ></insurance-auth-status>
    </common-modal>
</template>

<script>
    import dayjs from 'dayjs'
    import CommonButton from 'components/common/CommonButton'
    import InsuranceAuthStatus from 'components/page-elements/referrals/insurance-auth/InsuranceAuthStatus'
    import ReferralsAPI from 'api/ReferralsAPI'

    export default {
        components: { CommonButton, InsuranceAuthStatus },

        props: {
            referral: { type: Object, required: true, default: undefined },
        },

        data() {
            return {
                isAlreadyObtained: false,
                isAlreadyDeclined: false,
            }
        },

        computed: {
            title() {
                const refDate = dayjs(this.referral.appointmentDateTime)
                let hours = 1
                if (dayjs().add(24, 'h').isAfter(refDate)) {
                    hours = 24
                } else if (dayjs().add(48, 'h').isAfter(refDate)) {
                    hours = 48
                } else if (dayjs().add(72, 'h').isAfter(refDate)) {
                    hours = 72
                }
                return this.$tc('pages.referrals.show.insurance_modal.title', hours)
            },

            eventName() {
                return this.isAlreadyObtained || this.isAlreadyDeclined ? 'close' : 'close-and-show-info'
            },
        },

        methods: {
            declineInsuranceAuth() {
                const insuranceAuthAction = 'declined'
                this.referralAction(insuranceAuthAction)
            },

            obtainInsuranceAuth() {
                const insuranceAuthAction = 'obtained'
                this.referralAction(insuranceAuthAction)
            },

            referralAction(insuranceAuthAction) {
                ReferralsAPI.get(this.referral.id, this.$auth.getActiveMember().id).then((res) => {
                    if (res.state === 'OPEN' && res.status === 'INSURANCE_AUTH_PENDING') {
                        this.emitEvent({ name: insuranceAuthAction })
                    } else if (res.insuranceAuthorizationObtainedDateTime) {
                        this.isAlreadyObtained = true
                    } else {
                        this.isAlreadyDeclined = true
                    }
                })
            },
        },
    }
</script>

<style lang="scss" scoped>
    header {
        text-align: center;
        margin-top: 1rem;
        margin-bottom: 3rem;

        h4 {
            font-family: Poppins;
            font-size: 1.5rem;
            text-align: center;
            margin-bottom: 1rem;
            color: #333333;
        }
    }
    main {
        padding-bottom: 1rem;
    }
</style>
